import React, { useRef, useState, useEffect } from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import cn from 'classnames';
import { MinusSvg, PlusSvg } from '../../icons/index.js';
import styles from 'shop-views/QtyPicker.scss';

var QtyPicker = _ref => {
  var value = _ref.value,
      setValue = _ref.setValue,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      className = _ref.className;
  var inputRef = useRef(null);
  var t = useTranslate();

  var _useState = useState(value),
      displayQty = _useState[0],
      setDisplayQty = _useState[1];

  useEffect(() => {
    setDisplayQty(value);
  }, [value]);

  var setQty = qty => {
    var current = inputRef.current;

    if (Number.isNaN(qty) && current !== null) {
      current.value = value.toString();
      return;
    }

    var newValue = Math.min(max, Math.max(qty, min));
    setValue(newValue);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.qtyPicker, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": t("CART.DECREMENT"),
    className: styles.decrement,
    disabled: value <= min,
    onClick: () => setQty(value - 1)
  }, /*#__PURE__*/React.createElement("img", {
    src: MinusSvg,
    alt: t("CART.DECREMENT"),
    className: styles.minusIcon
  })), /*#__PURE__*/React.createElement("input", {
    ref: inputRef,
    className: styles.input,
    type: "text",
    "aria-label": t("CART.QUANTITY"),
    value: displayQty,
    onChange: e => setDisplayQty(e.target.value),
    onFocus: () => {
      if (inputRef.current) {
        inputRef.current.setSelectionRange(0, inputRef.current.value.length);
      }
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": t("CART.INCREMENT"),
    className: styles.increment,
    disabled: value >= max,
    onClick: () => setQty(value + 1)
  }, /*#__PURE__*/React.createElement("img", {
    src: PlusSvg,
    alt: t("CART.INCREMENT"),
    className: styles.plusIcon
  }))));
};

export { QtyPicker };
//# sourceMappingURL=index.js.map
